import { Component, OnInit, ViewChild } from '@angular/core';
import { RecPlanSearchService } from '../../rec-plan-search-service';
import { DxDataGridComponent } from 'devextreme-angular';
import { PlanNumComponent } from '../plan-num/plan-num.component';
import { PlanRoom2VM, SearchPlanRoom2ListVM } from '../../../shared/viewmodels/ISearchServiceReg';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-rec-plan-plannum-search-grid',
  providers: [RecPlanSearchService],
  templateUrl: './rec-plan-plannum-search-grid.component.html',
  styleUrls: ['./rec-plan-plannum-search-grid.component.css']
})
export class RecPlanPlannumSearchGridComponent implements OnInit {

  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild(PlanNumComponent, { static: false }) cplannum: PlanNumComponent;
  public recsresults: PlanRoom2VM[];
  //public recsresults: SearchPlanRoom2ListVM;
  //public recdoc: RecDocVM;
  public re: string;
  applyFilterTypes: any;
  currentFilter: any;
  showFilterRow: boolean;
  console = console;
  towns: string[] = [];
  doctypes: string[] = [];
  rolename: string;

  userInput: any;
  public errorMsg;

  focusedRowKey: number;
  recordCount: number;



  constructor(private service: RecPlanSearchService, private store: Store<AppState>, private router: Router, private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.store.select((state: any) => state).subscribe(data => this.userInput = data);

    this.getResults(
      this.userInput.coresearchdata.plannum[0].plannum
    );

    this.showFilterRow = true;
    this.applyFilterTypes = [{
      key: "auto",
      name: "Immediately"
    }, {
      key: "onClick",
      name: "On Button Click"
    }];

    this.currentFilter = this.applyFilterTypes[0].key;
  }

  getResults(plannum) {
    //let getRecPlanBPSearchQuery = new GetRecPlanBPSearchQuery({

    //  book: book,
    //  page: page
    //});

    this.service.SelectPlanByPlanID(Number(plannum)).subscribe(result => {

      this.recsresults = result["planRoom2Rows"];
      this.recordCount = this.recsresults.length;
    });



  }

  //getRecDoc(docId: number) {
  //  this.service.getRecDoc(docId).subscribe(
  //    data => { this.recdoc = data },
  //    error => { this.errorMsg = error }
  //  );
  //}



  clearFilter() {
    this.dataGrid.instance.clearFilter();
  }

  onInitialized(e) {

  }

  //Open image in another tab'
  imgClicked(event) {
    if (!this.dataGrid.instance.isRowSelected(event.row.key)) {
      this.dataGrid.instance.selectRows(event.row.key, false);
    }
    // this.nav.visible = false;


  }

  onExpanding(e) {
    this.focusedRowKey = e.component.option("focusedRowIndex");
    this.focusedRowKey = e.key.index;
    e.component.collapseAll(-1);
  }


  //export() {


  //  //this.console.log('Inside Export');
  //  let getRecNameSearchReportQuery = new GetRecNameSearchReportQuery({
  //    lastName: this.userInput.name[0].lastcorpName,
  //    firstName: this.userInput.name[0].fName,
  //    fromDate: this.userInput.date[0].fromDate,
  //    toDate: this.userInput.date[0].toDate,
  //    roleId: (this.userInput.role[0].roleID == -1) ? 0 : this.userInput.role[0].roleID,
  //    towns: this.towns,
  //    doctypes: this.doctypes,
  //    sortBy: new Array<string>(),
  //    sortDirection: "desc",
  //    filter: new Array<string>()
  //  });
  //  this.console.log(this.userInput.date[0].fromDate);
  //  this.console.log(getRecNameSearchReportQuery.toJSON());
  //  this.reportService.getRecNameSearchReport(getRecNameSearchReportQuery).subscribe((reportName) => {
  //    //this.reportUrl = reportName.reportName;
  //    this.console.log(`rerportName: ${reportName.reportName}`);
  //    this.router.navigate([`/report-viewer/${reportName.reportName}`]);

  //  });


  //}

}
